import React from "react";
import FormInput from "@/components/FormInput";
import AccountNumberInput from "@/components/FormInput/AccountNumberInput";
import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

const PersonalInformationStep = () => {
  const { control } = useFormContext();

  return (
    <>
      <Typography
        sx={{ padding: "0 0 16px 0", display: "flex" }}
        variant={"bodyRegular"}
      >
        Personal Information
      </Typography>

      <AccountNumberInput
        name={"accountHash"}
        label={"Account Number"}
        placeholder={"000000000000"}
        disabled={false}
        zipCodeName={"zipCode"}
        hideCustomerDataDisplay={true}
      />

      <Box sx={{ display: "flex", gap: "16px" }}>
        <FormInput
          name={"customerName"}
          control={control}
          label={"Account Name"}
          placeholder={"Add customer name"}
          disabled={false}
          readOnly={true}
          controlProps={{ rules: { required: "Required" } }}
        />
        <FormInput
          name={"zipCode"}
          control={control}
          type={"number"}
          label={"Zip Code"}
          placeholder={"Add zip code"}
          controlProps={{
            rules: {
              required: "Required",
              validate: (value) => {
                if (value?.length > 5) {
                  return "Zip code should be a max of 5 digits.";
                }
              },
            },
          }}
        />
      </Box>
    </>
  );
};

export default PersonalInformationStep;
